export default {
      id: "down-usage",
      viewBox: "0 0 14 10",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#down",
      toString: function () {
        return this.url;
      }
    }